import { RatePurpose } from 'app/profile/models/supplier-rating.model';


export interface SupplierRatingState {
    purposes: RatePurpose[] | null;
}

export const initialState: SupplierRatingState = {
    purposes: null
};